<template>
  <div class="subproperty-fee-info-page">
    <app-back-button />
    <h1 class="app-content-title" v-text="copies.title" />

    <div class="app-content-page subproperty-fee-info-page__content" v-loading="loading">
      <span class="subproperty-fee-info-page__content__title" v-text="copies.title" />
      <p class="subproperty-fee-info-page__content__description" v-text="copies.description" />
      <div class="subproperty-fee-info-page__content__fee-cards">
        <div
          v-for="(item, i) in feeList"
          :key="i"
          class="subproperty-fee-info-page__content__fee-cards__item"
        >
          <div class="subproperty-fee-info-page__content__fee-cards__item__body">
            <span
              class="subproperty-fee-info-page__content__fee-cards__item__body__percentage"
              v-text="item.percentage + '%'"
            />
            <span
              class="subproperty-fee-info-page__content__fee-cards__item__body__plus"
              v-text="'+'"
            />
            <app-i18n-amount
              class="subproperty-fee-info-page__content__fee-cards__item__body__amount"
              v-if="item.amount"
              :amount="item.amount"
              :currency="item.currency"
            />
          </div>
          <span
            class="subproperty-fee-info-page__content__fee-cards__item__info"
            v-text="item.info"
          />
        </div>
      </div>
      
      <div class="subproperty-fee-info-page__content__check-list">
        <div
          v-for="(item, i) in copies.checkList"
          :key="i"
          class="subproperty-fee-info-page__content__check-list__item"
        >
          <i class="subproperty-fee-info-page__content__check-list__item__icon icon-tick" />
          <span class="subproperty-fee-info-page__content__check-list__item__text" v-text="item" />
        </div>
      </div>
      <p class="subproperty-fee-info-page__content__small-text" v-text="copies.smallText"></p>
    </div>
  </div>
</template>

<script>
import { i18n } from '@shared/i18n';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'subpropertyFeeInfoPage',
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  created() {
    const { id } = this;
    this.doLoadFeeList({ subpropertyId: id });
  },
  computed: {
    ...mapGetters({
      feeList: 'subproperty/feeInfo/feeList',
      loading: 'subproperty/feeInfo/loading',
      country: 'subproperty/feeInfo/country',
    }),
    copies() {
      return {
        title: i18n('entities.subproperty.feeInfo.title'),
        description: i18n(
          'entities.subproperty.feeInfo.description',
        ),
        checkList: [
          i18n('entities.subproperty.feeInfo.checkList.0'),
          i18n('entities.subproperty.feeInfo.checkList.1'),
        ],
        smallText: i18n(
          'entities.subproperty.feeInfo.smallText',
          this.extraFee
        ),
      };
    },
    extraFee({ country }) {
      return country === 'US' ? '1%' : '2%'
    }
  },
  methods: {
    ...mapActions({
      doLoadFeeList: 'subproperty/feeInfo/doLoadFeeList',
    }),
    ...{ i18n },
  },
};
</script>

<style lang="scss" scoped>
.subproperty-fee-info-page {
  --white: #fff;

  &__content {
    text-align: center;
    padding: 64px;

    &__title {
      font-size: 38px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #4c4c4c;
    }
    &__description {
      font-size: 18px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #a9a9a9;
    }
    &__fee-cards {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      &__item {
        padding: 64px 72px;
        margin: 20px 20px;
        max-width: 500px;
        min-width: 250px;
        border-radius: 6px;
        box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
        border: solid 1px #dbdbdb;
        background-color: var(--white);

        &__body {
          &__percentage {
            color: #404040;
            font-size: 40px;
            font-weight: bold;
            letter-spacing: 0.53px;
          }
          &__plus {
            color: #c5c5c5;
            font-size: 40px;
            font-weight: bold;
            margin: 16px;
          }
          &__amount {
            color: #404040;
            font-size: 32px;
            letter-spacing: 0.5px;
          }
        }
        &__info {
          margin: 24px 0 0 0;
          color: #c5c5c5;
          font-size: 20px;
        }
      }
    }
    &__check-list {
      display: flex;
      flex-direction: column;
      text-align: left;
      padding: 40px 0;
      &__item {
        display: flex;
        margin: 8px auto;
        width: 400px;
        align-items: center;
        &__icon {
          color: #2acccc;
          font-size: 28px;
          margin: 0 16px 0 0;
        }
        &__text {
          size: 20px;
          color: #404040;
        }
      }
    }
    &__small-text {
      padding: 40px 40px 0 40px;
      color: #a9a9a9;
      size: 12px;
    }
  }
}
</style>
